import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateItem } from "@factory/query/item.query";
import { ItemFormRule, ItemFormSchema } from "@factory/form/form.rule";
import { itemFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useUserIdentityContext } from "@core/services/user-identity.context";

export function useNewItem() {
 // LOCAL DECLARATION
  const { getUserRole } = useUserIdentityContext();
  const navigate = useNavigate();
  const { mapCreateItem } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Item is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addItem, isLoading: isCreating } =
    useQyCreateItem(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ItemFormSchema>({
    defaultValues: itemFormDefault,
    resolver: zodResolver(ItemFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ItemFormSchema) => {
    const { tenant } = getUserRole();
    const updatedForm = {
      ...form,
      tenant,
    };
    const formData = mapCreateItem(updatedForm);
    addItem(formData);
  };
  const handleValidateError = (err: FieldErrors<ItemFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
